
import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { SubmitDealHero } from './components/SubmitDealHero';
import { DealPricingPlans } from './components/DealPricingPlans';
import { DealSubmissionForm } from './components/DealSubmissionForm';
import { DealExamples } from './components/DealExamples';
import { DealBenefits } from './components/DealBenefits';
import { useSEO, generateBreadcrumbSchema } from '../../utils/seo';

export default function SubmitDealPage() {
  const [selectedPlan, setSelectedPlan] = useState<'standard' | 'featured' | null>(null);

  useSEO({
    title: 'Submit a Deal | List Local Discounts & Coupons in Roseville CA | Roseville.org',
    description: 'Submit your business deal or coupon to Roseville.org. Reach 50,000+ local shoppers in Roseville, California. Standard and featured deal listing options available.',
    keywords: 'submit deal Roseville, list coupon Roseville CA, Roseville business deals, local discounts Roseville, advertise deals Roseville.org',
    canonical: '/submit-deal',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          name: 'Submit a Deal — Roseville.org',
          description: 'Submit your business deal or coupon to reach local Roseville, CA shoppers.',
          url: `${import.meta.env.VITE_SITE_URL || 'https://roseville.org'}/submit-deal`,
          inLanguage: 'en-US',
        },
        generateBreadcrumbSchema([
          { name: 'Home', url: '/' },
          { name: 'Deals', url: '/deals' },
          { name: 'Submit a Deal', url: '/submit-deal' },
        ]),
      ],
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <SubmitDealHero />
      <DealBenefits />
      <DealPricingPlans onSelectPlan={setSelectedPlan} selectedPlan={selectedPlan} />
      <DealExamples />
      {selectedPlan && <DealSubmissionForm selectedPlan={selectedPlan} />}
      <Footer />
    </div>
  );
}
